import { usePathname } from "next/navigation";
import { AnalyticsEvents } from "~/connectors/analyticsEvents";
import Link from "../Link";
import Logo from "./Logo";

import Typography from "@mui/material/Typography";

export default function LogoLink() {
  const pathname = usePathname();

  return (
    <Link
      button
      color="inherit"
      href="/"
      trackable={AnalyticsEvents.LOGO_CLICK}
      sx={{
        whiteSpace: "nowrap",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Logo width={28} height={28} sx={{ mr: "0px" }} />
      <Typography
        variant="h6"
        sx={{
          fontFamily: "var(--font-body)",
          fontWeight: pathname === "/" ? 700 : 400,
          fontSize: { xs: "1rem", md: "1.15rem" },
        }}
      >
        Cântecelul Meu
      </Typography>
    </Link>
  );
}
